module.exports = __webpack_public_path__ + "images/emoji/door.f85c61fb482fc899e485.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/door.png
// module id = gVIg
// module chunks = 2